<template>
  <div class="base-side-menu">
    <el-menu :default-openeds="defaultOpens" :default-active="defaultActive" @select="handleSelect">
      <div v-for="menu in menuList" :key="menu.value">
        <el-submenu v-if="menu.children" :index="menu.value">
          <template slot="title">
            <span>
              <svg-icon
                :icon-class="'display_' + menu.icon"
                style="margin-right: 5px; font-size: 18px;"
              ></svg-icon>
            </span>
            <span>{{ menu.label }}</span>
          </template>
          <el-menu-item
            v-for="(item, index) in menu.children"
            :key="index"
            :index="item.value"
            style="margin-left: 10px"
          >
            <span slot="title">{{ item.label }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :key="menu.value" :index="menu.value">
          <span>
            <svg-icon
              :icon-class="'display_' + menu.icon"
              style="margin-right: 5px; font-size: 18px;"
            ></svg-icon>
          </span>
          <span slot="title">{{ menu.label }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "BaseSideMenu",
  props: {
    menuList: Array,
    defaultMenu: Array
  },
  computed: {
    defaultOpens() {
      return this._.isEmpty(this.defaultMenu) ? [] : this.defaultMenu
    },
    defaultActive() {
      return this._.isEmpty(this.defaultMenu) ? this.$route.name : null
    }
  },
  methods: {
    handleSelect(routeName) {
      if (this.$route.name === routeName) return
      if (routeName === "admin-workflow") {
        this.$router.push({ name: routeName, query: { group: "START_TYPE_DATA", page: "1" } })
      } else {
        this.$router.push({ name: routeName })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-side-menu {
  ::v-deep .el-menu {
    border-right: none;
    .el-menu-item,
    .el-submenu__title {
      font-size: 14px;
      height: 48px;
      line-height: 48px;
    }
    .el-submenu__icon-arrow {
      font-size: 16px;
    }
  }
}
</style>
